import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft, Home } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * Shown when a user navigates directly to a route they don't have permission to access.
 *
 * While unauthorized routes are hidden from the sidebar, users can still
 * access them via direct URL entry or bookmarks. This page provides:
 * - Clear feedback that access is denied
 * - Navigation options to return to safety
 */
export function AccessDeniedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <div className="flex flex-col items-center text-center">
        <div className="mb-6 rounded-full bg-destructive/10 p-4">
          <ShieldAlert className="h-12 w-12 text-destructive" />
        </div>

        <h1 className="mb-2 text-2xl font-semibold">Acceso Denegado</h1>

        <p className="mb-8 max-w-md text-muted-foreground">
          No tienes permiso para acceder a esta pagina. Si crees que esto es un
          error, contacta a tu administrador.
        </p>

        <div className="flex gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver
          </Button>
          <Button onClick={() => navigate("/")}>
            <Home className="mr-2 h-4 w-4" />
            Ir al Inicio
          </Button>
        </div>
      </div>
    </div>
  );
}
